import { Factory } from './factory';
import { SchoolbagFile } from '../schoolbag-file';

export class SchoolBagFileFactory implements Factory<SchoolbagFile> {

    buildFromFactory(): SchoolbagFile {
        return undefined;
    }

    buildFromObject(jsonObject: any): SchoolbagFile {
        const schoolBagFile = new SchoolbagFile();
        schoolBagFile.id = +jsonObject.id;
        schoolBagFile.name = jsonObject.name;
        schoolBagFile.bookLink = jsonObject.bookLink;
        schoolBagFile.pdfLink = jsonObject.pdfLink;
        schoolBagFile.pdfOnly = jsonObject.pdfOnly;
        schoolBagFile.uploadedAt = jsonObject.uploadedAt;

        return schoolBagFile;
    }

}
